module.exports = __webpack_public_path__ + "static/media/Nguyen_Duc_Long.9c1240a4.jpg";